import {
	Button,
	CircularProgress,
	FormControl, Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
	Link
} from "@material-ui/core"
import React, { useState } from "react"
import { Notification } from "@/components"
import { AccountAdminApi, InboxAdminApi } from "@/services/Api"
import useStyles from "@/pages/Tools/ToolsPages/MassNotifySubscriptionsToolPage/styles"
import {
	NOTIFICATION_OPTIONS,
	NotificationTypes
} from "@/shared/constants/notificationConstants"
import { botLinks } from "@/utils/links"
import useValidation, { ErrorType } from "@/hooks/useValidation"
import { AccountDataResponse, MassNotifyPayload } from "@/pages/Account/protocols/SubscriptionProtocol"

const MassNotifySubscriptionsToolPage = () => {
	const classes = useStyles()

	const [instanceIds, setInstanceIds] = useState("")
	const [notificationType, setNotificationType] = useState<NotificationTypes>("block_warning")
	const [loading, setLoading] = useState(false)
	const { validation, triggerValidation, clearValidation } = useValidation()

	const parseInstanceIds = (instanceIds: string): string[] => {
		return instanceIds
			.split(",")
			.map(id => id.trim())
			.filter(entry => entry !== "")
	}

	const fetchAccountAndInstanceIds = async (validInstanceIds: string[]): Promise<MassNotifyPayload[]> => {
		const response = await InboxAdminApi.get<{ data: AccountDataResponse[] }>(
			"/instances/accountData",
			{
				params: {
					instance_ids: validInstanceIds
				}
			}
		)

		const accountAppInstanceIds: MassNotifyPayload[] = response.data.data.map(item => ({
			appInstanceId: item.accountInstanceId,
			accountId: item.ownerUserAccountId
		}))

		return accountAppInstanceIds
	}

	const handleSendMassNotification = async () => {
		const validInstanceIds = parseInstanceIds(instanceIds)

		setLoading(true)

		try {
			const accountAppInstanceIds = await fetchAccountAndInstanceIds(validInstanceIds)

			await AccountAdminApi.post("/subscriptions/mass-notify", {
				accountAppInstanceIds,
				notificationType
			})

			Notification.success({ message: "Notificações enviadas para os responsáveis pela assinatura com sucesso!" })
			setInstanceIds("")
		} catch (error) {
			triggerValidation(error as ErrorType)
		} finally {
			setLoading(false)
		}
	}

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Grid container direction="column" spacing={1}>
					<Grid item>
						<Typography color="textPrimary" variant="h4">
                    Notificar assinaturas em massa
						</Typography>
					</Grid>

					<Grid item>
						<Typography color="textSecondary" variant="subtitle1">
                    Insira os IDs das instâncias que você deseja notificar, <strong>separados por vírgula</strong>.
						</Typography>
					</Grid>
				</Grid>
			</Grid>

			<Grid item xs={12} className={classes.notifyContainer}>
				<Grid container direction="column">
					<Grid item md={8}>
						<Grid container direction="column" spacing={1}>
							<Grid item>
								<FormControl fullWidth variant="outlined" className={classes.formControl}>
									<Grid container>
										<Grid item>
											<InputLabel id="notification-type-label">Tipo de Notificação</InputLabel>
										</Grid>

										<Grid item>
											<Select
												labelId="notification-type-label"
												value={notificationType}
												onChange={({ target }) => setNotificationType(target.value as NotificationTypes)}
												label="Tipo de Notificação"
											>
												{NOTIFICATION_OPTIONS.map(({ label, value }) => (
													<MenuItem key={value} value={value}>
														{label}
													</MenuItem>
												))}
											</Select>
										</Grid>
									</Grid>
								</FormControl>
							</Grid>

							<Grid item>
								<TextField
									label="IDs das Instâncias"
									placeholder="Ex: 7524, 5644, 7168..."
									multiline
									rows={8}
									variant="outlined"
									fullWidth
									value={instanceIds}
									onChange={(e) => {
										setInstanceIds(e.target.value)
										clearValidation("instanceIds")
									}}
									className={classes.textArea}
									error={!!validation.instanceIds}
									helperText={validation.instanceIds}
								/>
							</Grid>
						</Grid>
					</Grid>

					<Grid item>
						<Grid container direction="column" spacing={1}>
							<Grid item>
								<Typography
									variant="h5"
								>
							*Comunicação realizada por <Link href={botLinks.subscriptionNotification}>bot na instância 1745</Link>
								</Typography>
							</Grid>

							<Grid item>
								<Button
									variant="contained"
									color="primary"
									onClick={handleSendMassNotification}
									disabled={loading || !instanceIds}
									className={classes.executeButton}
									endIcon={loading && <CircularProgress size={20} color="inherit" />}
								>
									{loading ? "Notificando..." : "Notificar"}
								</Button>
							</Grid>
						</Grid>

					</Grid>
				</Grid>

			</Grid>
		</Grid>
	)
}

export default MassNotifySubscriptionsToolPage
